export const isNativeFile = (fileItem) => "lastModified" in fileItem;
//# sourceMappingURL=file-type-checker.js.map